import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatterDispatch } from '@state/matter';
import { deleteField } from '@angular/fire/firestore';

export enum DeleteModalTypes {
	MANAGEMENT_COMPANY = 'Management Company',
	CONDO_CORPORATION = 'Condo Corporation',
}

@Component({
	selector: 'app-condo-corporation-modal',
	templateUrl: './delete-confirmation-modal.component.html',
	standalone: false,
})
export class DeleteConfirmationModalComponent {
	public type: DeleteModalTypes;

	constructor(
		public dialogRef: MatDialogRef<DeleteConfirmationModalComponent>,
		private matterDispatch: MatterDispatch,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			deleteModalType: DeleteModalTypes;
		},
	) {
		this.type = data?.deleteModalType;
	}

	cancel() {
		this.dialogRef.close();
	}

	delete() {
		if (this.type === DeleteModalTypes.CONDO_CORPORATION) {
			this.matterDispatch.OverwriteFields('condoCorporation', deleteField());
		} else if (this.type === DeleteModalTypes.MANAGEMENT_COMPANY) {
			this.matterDispatch.OverwriteFields(
				'condoCorporation.management',
				deleteField(),
				['condoCorporation.attention', deleteField()],
			);
		}
		this.dialogRef.close();
	}
}
